<template lang="pug">
  .panel-page-white
    .panel-white.mx-auto
      ICEAlert
      h1 Search Results
      .body-1
        | Search results for 
        span(v-if="nameSearch")
          | Person:
          strong  "{{displayName}}"
          span(v-if="criteria.dateOfBirth")
            |  and Date of Birth:
            strong  "{{criteria.dateOfBirth}}".
        span(v-if="uniqueIdSearch")
          |  Unique ID:
          strong  "{{criteria.uniqueId}}".
        span(v-if="addressSearch")
          |  Address:
          strong  "{{criteria.address}}. {{criteria.city}}, {{criteria.state}} {{criteria.zip}}"
        span(v-if="locationSearch")
          |  Locations:
          strong  "{{criteria.searchStates.join(', ')}}"
      Datatable(:columns="columnNames"
                :entries="personResults"
                tableKey="resultsTable"
                :perPage="6"
                class="mt-2"
                :header-style="{fontSize: '0.8125rem'}")
        template(slot-scope="props")
          tr
            td.body-2
              router-link(:to="{name: 'person_summary', params: { id: props.entry.subjectSid } }") View Summary
            td.body-2
              div {{ props.entry.lastName }}, {{ props.entry.firstName }}
              div(v-if="props.entry.watchCount > 0")
                img.watch-logo(src="../assets/img/watch.png" alt="watch count")
                div
                  span.h7 Being watched by Agency(ies) - {{ props.entry.watchCount }}
            td.body-2 {{ props.entry.birthDt }}
            td.body-2(v-if="props.entry.idNbr") {{ props.entry.idNbr }} / {{ props.entry.idTypeDesc }} / {{ props.entry.idStateCd }}
            //- Space added for formatting
            td.body-2(v-else) &nbsp; 
            td.body-2 {{ props.entry.transactionDt }}
            td.body-2 {{ props.entry.transactionCd }}
            td.body-2
              div {{ props.entry.pharmacyName }}
              div {{ props.entry.pharmacyAddress1 }}
              div {{ props.entry.pharmacyAddress2 }}
              div {{ props.entry.pharmacyCity }}, {{ props.entry.pharmacyStateCd }}
              div {{ props.entry.pharmacyPhone }}
</template>

<script>
import axios from '@/lib/axios'
import Datatable from '@/components/Datatable'
import router from '@/router'
import store from '@/store'
import { globalError } from '@/lib/utils'

export default {
  name: 'SearchResults',
  data: function() {
    return {
      personResults: [],
      criteria: {},
      columnNames: [
        'Summary',
        'Name',
        'Date of Birth',
        'ID',
        'Transaction Date',
        'Transaction Type',
        'Pharmacy',
      ],
      slotNames: [
        'summary',
        'name',
        'dob',
        'id',
        'transactionDate',
        'transactionType',
        'pharmacy',
      ],
    }
  },
  methods: {
    sortResults(sortObj) {
      let personResults = this.personResults.slice(0)
      let { sortKey, sortDir } = sortObj
      personResults.sort((val1, val2) => {
        if (val1[sortKey] < val2[sortKey]) return -1
        else if (val1[sortKey] > val2[sortKey]) return 1
        else return 0
      })
      if (sortDir === 'desc') personResults.reverse()
      this.$emit('update:personResults', personResults)
    },
  },
  computed: {
    nameSearch() {
      return this.criteria['lastName'] || this.criteria['firstName']
    },
    displayName() {
      return `${this.criteria['lastName']}, ${this.criteria['firstName']}`
    },
    uniqueIdSearch() {
      return this.criteria.uniqueId
    },
    addressSearch() {
      return this.criteria.address
    },
    locationSearch() {
      return this.criteria.searchStates && this.criteria.searchStates.length > 0
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      let resp = await axios().get(
        `/api/search/search_results?id=${to.query.id}`,
      )
      scrollTo(0, 0)
      next(vm => {
        vm.criteria = resp.data.criteria
        vm.personResults = resp.data.results
      })
    } catch (err) {
      router.push({ name: 'dashboard' })
      globalError(err)
    }
    store.commit('resetLoader')
  },
  components: {
    Datatable,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';
.panel-white {
  @media (min-width: $bp-lg) {
    width: 80%;
  }
}
h1 {
  border-bottom: 2px solid #e6e6e6;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}
.watch-logo {
  width: 2rem;
}
</style>
